import { render, staticRenderFns } from "./ElOrderForm.vue?vue&type=template&id=2348eb01"
import script from "./ElOrderForm.vue?vue&type=script&lang=js"
export * from "./ElOrderForm.vue?vue&type=script&lang=js"
import style0 from "./ElOrderForm.vue?vue&type=style&index=0&id=2348eb01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports